import * as React from 'react';
import { Slot, Slottable } from '@radix-ui/react-slot';
import { type VariantProps } from 'tailwind-variants';

import { cn, tv } from '../utils';

/* -------------------------------------------------------------------------------------------------
 * Link
 * -----------------------------------------------------------------------------------------------*/

const linkVariants = tv({
	base: '',
	variants: {
		variant: {
			default: cn('text-info-500 hover:underline cursor-pointer', 'dark:text-info-400'),
			unstyled: '',
		},
	},
	defaultVariants: {
		variant: 'default',
	},
});

export interface UiLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>, VariantProps<typeof linkVariants> {
	asChild?: boolean;
}

const UiLink = React.forwardRef<HTMLAnchorElement, UiLinkProps>((props, ref) => {
	const { children, className, variant, asChild = false, ...rest } = props;
	const Comp = asChild ? Slot : 'a';
	return (
		<Comp className={cn(linkVariants({ variant, className }))} ref={ref} {...rest}>
			<Slottable>{children}</Slottable>
		</Comp>
	);
});
UiLink.displayName = 'ui/Link';

/* -----------------------------------------------------------------------------------------------*/

export { UiLink, linkVariants };
